module.exports = {
  title: 'A website for all things Nick. A near limitless supply of accounts I barely use.',
  img: 'img/brand/white.png',
  buttons: [
    {
      title: 'Software',
      dest: 'software',
      class: 'mb-3 mb-sm-0 text',
      type: 'info',
      fa: {
        icon: 'code',
        size: 'lg'
      }
    },
    {
      title: 'Art',
      dest: 'art',
      class: 'mb-3 mb-sm-0',
      type: 'white',
      fa: {
        icon: 'image',
        size: 'lg'
      }
    },
  ]
}